import { useQuery } from '@tanstack/react-query'
import { systemRepository } from '../repositories/system.repository'
import { SystemDefaultType } from '@/models/system-default'

const SYSTEM_DEFAULTS_KEY = 'system-defaults'

export const useSystemDefaults = () => {
  const {
    data: systemDefaults,
    isLoading: dataIsLoading,
    error: dataError,
    refetch
  } = useQuery({
    queryKey: [SYSTEM_DEFAULTS_KEY],
    queryFn: systemRepository.getDefaults,
    staleTime: 10 * 60 * 1000, // 10 minutes - system defaults change rarely
  })

  // Helper to get specific default value
  const getDefaultValue = (key: string) => {
    return systemDefaults?.find(item => item.name === key)?.value
  }

  // Common system defaults
  const getWalletAddress = () => getDefaultValue(SystemDefaultType.WALLET_ADDRESS)
  const getCompanyName = () => getDefaultValue('company_name')
  const getSupportEmail = () => getDefaultValue('support_email')

  return {
    // Data
    systemDefaults: systemDefaults || [],
    
    // Loading and error states
    dataIsLoading,
    dataError,
    
    // Helpers
    getDefaultValue,
    getWalletAddress,
    getCompanyName,
    getSupportEmail,
    
    // Actions
    refetch
  }
}